import * as actionTypes from "../actions/types.js";
export default (state = { employeeSubscriberList: [],usercoursedetails:[],courseUserList:[],allCourseList:[],courseSubCategoryList:[],courseTopicList:[],viewTopicData:{},courseemplist:[],coursesublist:[],employeeCourselist:[] ,courseempviewlist:{},CourseCategoryList:[],CourseSubCategoryList:[],CourseTopicList:[],tableList:'1',breadCat:'',breadSubCat:'',breadTopic:''}, action) => {
  switch (action.type) {
    case actionTypes.EMPLOYEE_SUBSCRIBERS_LIST:
      return {
        ...state,
        employeeSubscriberList: action.payload ? action.payload : [],
      };
    case actionTypes.COURSE_USER_LIST:
      return {
        ...state,
        courseUserList: action.payload ? action.payload : [],
      };
    case actionTypes.COURSE_SUB_CATEGORY_LIST:
      return {
        ...state,
        courseSubCategoryList: action.payload ? action.payload : [],
      };
    case actionTypes.COURSE_SUB_TOPIC_LIST:
      return {
        ...state,
        courseTopicList: action.payload ? action.payload : [],
      };
    case actionTypes.COURSE_TOPIC_VIEW_DATA:
      return {
        ...state,
        viewTopicData: action.payload ? action.payload : {},
      };

      ///
    case actionTypes.COURSE_SUBSCRIBERS_LIST:
      return {
        ...state,
        coursesublist: action.payload ? action.payload : {},
      };
    case actionTypes.COURSE_EMPLOYEES_LIST:
      return {
        ...state,
        courseemplist: action.payload ? action.payload : {},
      };
    case actionTypes.COURSE_USER_COURSE_DETAILS:
      return {
        ...state,
        usercoursedetails: action.payload ? action.payload : [],
      };
    case actionTypes.COURSE_EMPLOYEES_VIEW_LIST:
      return {
        ...state,
        courseempviewlist: action.payload ? action.payload : {},
      };
    case actionTypes.COURSE_EMPLOYEES_COURSE_LIST:
      return {
        ...state,
        employeeCourselist: action.payload ? action.payload : [],
      };
    case actionTypes.ALLCOURSE_DATA:
      return {
        ...state,
        allCourseList: action.payload ? action.payload : [],
      };
    case actionTypes.CATEGORY_COURSE_DATA:
      return {
        ...state,
        CourseCategoryList: action.payload ? action.payload : [],
      };
    case actionTypes.SUBCATEGORY_COURSE_DATA:
      return {
        ...state,
        CourseSubCategoryList: action.payload ? action.payload : [],
      };
    case actionTypes.TOPIC_COURSE_DATA:
      return {
        ...state,
        CourseTopicList: action.payload ? action.payload : [],
      };
    case actionTypes.LIST_TABLE:
      return {
        ...state,
        tableList: action.payload ? action.payload : '1',
      };
    case actionTypes.BREAD_TITLE_CAT:
      return {
        ...state,
        breadCat: action.payload ? action.payload : '',
      };
    case actionTypes.BREAD_TITLE_SUBCAT:
      return {
        ...state,
        breadSubCat: action.payload ? action.payload : '',
      };
    case actionTypes.BREAD_TITLE_TOPIC:
      return {
        ...state,
        breadTopic: action.payload ? action.payload : '',
      };
    default:
      return state;
  }
};
